import { observer } from 'mobx-react-lite';

import { TextField } from '@components/text-field';
import { asteriskLabel } from '@utils/strings';

import { useStore } from 'models/stores';

export default observer(({ form, required = false, field = '' }) => {
  const {
    uiStore: { t },
  } = useStore();
  const label = t(`apply_${field}_label`);

  return (
    <TextField
      label={asteriskLabel(label, required)}
      value={form[field] ?? ''}
      onChange={(value) => form.set(field, value)}
      error={form.errors.get(field) ? t(form.errors.get(field).error) : ''}
      isDisabled={form.disabled}
      isFullWidth
    />
  );
});
